// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import { VIABILITY_ADDRESS } from '../../../../../../../utility/SourceAPI'

export const getViability = createAsyncThunk('appViability/getViability', async () => {
    const response = await axios.get(VIABILITY_ADDRESS)
    return response.data
})

export const addViability = createAsyncThunk('appViability/addViability', async (viability, { dispatch }) => {
    const response = await axios.post(VIABILITY_ADDRESS, viability)
    await dispatch(getViability())
    return response.data
})

export const appViabilitySlice = createSlice({
    name: 'appViability',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getViability.fulfilled, (state, action) => {
            state.data = action.payload
        })
    }
})

export default appViabilitySlice.reducer